export const QuestionTypesActionTypes = {
  API_RESPONSE_SUCCESS: '@@question-type/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@question-type/API_RESPONSE_ERROR',

  GET_QUESTION_TYPE: '@@question-type/GET_QUESTION_TYPE',
  LIST_QUESTION_TYPES: '@@question-type/LIST_QUESTION_TYPES',
  ADD_QUESTION_TYPE: '@@question-type/ADD_QUESTION_TYPE',
  UPDATE_QUESTION_TYPE: '@@question-type/UPDATE_QUESTION_TYPE',
  DELETE_QUESTION_TYPE: '@@question-type/DELETE_QUESTION_TYPE',

  RESET: '@@question-type/RESET'
}
